import React from 'react'
import { ChevronRight, Home } from 'lucide-react'

interface BreadcrumbItem {
  nodeId: string
  label: string
}

interface BreadcrumbNavProps {
  path: BreadcrumbItem[]
  taxonomyLabel: string
  onNavigate: (nodeId: string | null) => void
}

const BreadcrumbNav: React.FC<BreadcrumbNavProps> = ({ path, taxonomyLabel, onNavigate }) => {
  return (
    <nav className="flex items-center gap-1 text-sm overflow-x-auto py-2 px-1">
      <button
        onClick={() => onNavigate(null)}
        className="flex items-center gap-1 text-gray-500 hover:text-acad-600 transition-colors shrink-0"
        title="Return to root"
      >
        <Home className="w-4 h-4" />
        <span className="hidden sm:inline">{taxonomyLabel}</span>
      </button>

      {path.map((item, index) => {
        const isLast = index === path.length - 1
        return (
          <React.Fragment key={item.nodeId}>
            <ChevronRight className="w-3.5 h-3.5 text-gray-300 shrink-0" />
            {isLast ? (
              <span className="font-semibold text-acad-600 truncate max-w-[200px]">
                {item.label}
              </span>
            ) : (
              <button
                onClick={() => onNavigate(item.nodeId)}
                className="text-gray-500 hover:text-acad-600 transition-colors truncate max-w-[200px]"
              >
                {item.label}
              </button>
            )}
          </React.Fragment>
        )
      })}
    </nav>
  )
}

export default BreadcrumbNav
